export function validateEmail(email: string): boolean {
  const re = /^.+@.+(\.[^\\.]+)+$/;
  return re.test(email);
}

export function validatePassword(value: string): boolean {
  const re = /(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=\S+$).{8,}/;
  return re.test(value);
}

export function validatePhoneNumber(value: string): boolean {
  const re = /\d+$/;
  return re.test(value);
}

export function validatePhonePrefix(value: string): boolean {
  const re = /^[+]\d+$/;
  return re.test(value);
}

export function validateMobileNumber(value: string): boolean {
  const gte10Characters = value.length >= 10;
  return validatePhoneNumber(value) && gte10Characters;
}

export function validateAmount(amount: number): boolean {
  const re = /^\+?(0|[1-9]\d*)$/;
  return re.test(amount.toString()) && amount > 0;
}

export function validateMinAmount(min: number) {
  return (amount: number): boolean => amount >= min;
}

export function validateMaxAmount(min: number) {
  return (amount: number): boolean => amount <= min;
}

export function validateNoNumbers(value: string): boolean {
  const re = /^[^0-9]+$/;
  return re.test(value);
}
